export const AUTH_TOKEN_NAME = 'access_token'
export const EMAIL_TOKEN_NAME = 'rahmat_token'
export const CLIENT_ID_NAME = 'Client_id'
export const TOKEN_CREATED = 'Token_created'
export const ROLES = 'roles'
export const BRANCH_ID = 'branch_id'
export const UID = 'uid'

export const useAuthService = () => {
  const getToken = (): string | null => localStorage.getItem(AUTH_TOKEN_NAME)

  const getUID = (): string | null => localStorage.getItem(UID)
  const setUID = (id: string) => localStorage.setItem(UID, id)

  // const getRoles = (): Roles[] | undefined => localStorage.getItem(ROLES)?.split(',').map(i => i as Roles);

  const setToken = (token: string): void => localStorage.setItem(AUTH_TOKEN_NAME, token)

  const setRahmatToken = (token: string): void => {
    localStorage.setItem(EMAIL_TOKEN_NAME, token)
    // const isProd = import.meta.env.MODE === 'production'
    // const key = isProd ? 'token' : 'devToken'
    // let secure = ''
    // let sameSite = ''
    // let domain = ''
    // if (import.meta.env.MODE === 'production') {
    //   domain = 'Domain=.rhmt.uz; '
    //   secure = 'Secure; '
    //   sameSite = 'SameSite=None; '
    // }
    // if (import.meta.env.MODE === 'development') {
    //   domain = 'Domain=qr-admin-menu-dev.rhmt.uz; '
    // }
    // document.cookie = `${key}=${token}; Path=/; ${domain}${secure}${sameSite}Max-Age=${30 * 24 * 3600}`
  }

  const setRoles = (roles: string): void => localStorage.setItem(ROLES, roles)

  const removeRoles = () => localStorage.removeItem(ROLES)

  const removeToken = () => {
    localStorage.removeItem(AUTH_TOKEN_NAME)
    // localStorage.removeItem(EMAIL_TOKEN_NAME)
    removeRahmatToken()
  }

  const removeRahmatToken = () => {
    localStorage.removeItem(EMAIL_TOKEN_NAME)
    // const isProd = import.meta.env.MODE === 'production'
    // const key = isProd ? 'token' : 'devToken'
    // let secure = ''
    // let sameSite = ''
    // let domain = ''
    // if (import.meta.env.MODE === 'production') {
    //   domain = 'Domain=.rhmt.uz; '
    //   secure = 'Secure; '
    //   sameSite = 'SameSite=None; '
    // }
    // if (import.meta.env.MODE === 'development') {
    //   domain = 'Domain=qr-admin-menu-dev.rhmt.uz; '
    // }
    // document.cookie = `${key}=; Path=/; ${domain}${secure}${sameSite}Max-Age=0`
  }

  const getRahmatToken = (): any => {
    return localStorage.getItem(EMAIL_TOKEN_NAME)
    // const isProd = import.meta.env.MODE === 'production'
    // const key = isProd ? 'token' : 'devToken'
    // const cookieValue = document.cookie
    //   .split('; ')
    //   .find(row => row.startsWith(`${key}=`))
    // return cookieValue ? cookieValue.split('=')[1] : null
  }

  const setRegToken = (token: string): void => localStorage.setItem('reg_token', token)
  const getRegToken = (): string | null => localStorage.getItem('reg_token')
  const removeRegToken = (): void => localStorage.removeItem('reg_token')

  const getClientId = (): string | null => localStorage.getItem(CLIENT_ID_NAME)

  const setClientId = (client_id: string): void => localStorage.setItem(CLIENT_ID_NAME, client_id)

  const removeClientId = () => localStorage.removeItem(CLIENT_ID_NAME)

  const getTokenTime = (): string | null => localStorage.getItem(TOKEN_CREATED)

  const setTokenTime = (time: string): void => localStorage.setItem(TOKEN_CREATED, time)

  const removeTokenTime = (): void => localStorage.removeItem(TOKEN_CREATED)

  const getBranchId = (): number => Number.parseInt(localStorage.getItem(BRANCH_ID) ?? '0')

  const setBranchId = (branchId: number): void =>
    localStorage.setItem(BRANCH_ID, branchId.toString())

  const removeBranchId = (): void => localStorage.removeItem(BRANCH_ID)

  return {
    getToken,
    setToken,
    removeToken,
    setRahmatToken,
    removeRahmatToken,
    getRahmatToken,
    getClientId,
    setClientId,
    removeClientId,
    getTokenTime,
    setTokenTime,
    removeTokenTime,
    // getRoles,
    setRoles,
    removeRoles,
    getBranchId,
    setBranchId,
    removeBranchId,

    getUID,
    setUID,
    setRegToken,
    getRegToken,
    removeRegToken,
  }
}
